<section>
  <ul class="nav nav-tabs mb-3">
    @for (product of products; track product.product) {
      <li class="nav-item">
        <button
          class="nav-link"
          type="button"
          [class.active]="value().product === product.product"
          [id]="'company-download-tab-' + product.product"
          (click)="productChangeHandler(product.product)">
          {{ product.label }}
        </button>
      </li>
    }
  </ul>

  @for (platform of visiblePlatforms(); track platform.name) {
    <div class="border rounded mb-3">
      <strong class="d-flex align-items-center px-3 pt-3 pb-2">
        <span
          class="mr-2"
          [class]="platform.icon"></span>
        {{ platform.name }}
      </strong>

      @for (row of visibleRows(platform); track row.label) {
        <div
          class="px-3 py-2"
          [class.border-top]="!$first">
          <div class="form-row align-items-center text-md">
            <div class="col-4 fw-semibold">{{ row.label }}:</div>

            <div class="col">
              @if (row.appLink) {
                <mbs-button
                  [isCtrl]="true"
                  [size]="mbsSize.sm"
                  (click)="appLinkClickHandler(row.appLink)">
                  {{ appLinkLabel(row.appLink) }}
                </mbs-button>

                <mbs-button
                  class="ml-1"
                  icon="fa fa-clone"
                  [isCtrl]="true"
                  [ngbTooltip]="'shared:buttons.copyLink' | i18next"
                  [size]="mbsSize.sm"
                  (click)="copyAppLinkClickHandler(row.appLink)"></mbs-button>
              } @else {
                @let build = buildsByType()[row.buildType];
                @let channels = availableChannels(build);

                @for (channel of channels; track channel.type) {
                  @let unsupportedByCompany = isUnsupportedByCompany(build, channel.type);

                  <span
                    class="d-inline-block"
                    container="body"
                    [ngbTooltip]="unsupportedByCompany ? ('shared:download-build.versionIsUnsupportedByCompany' | i18next) : ''">
                    <mbs-button
                      [disabled]="unsupportedByCompany"
                      [isCtrl]="true"
                      [size]="mbsSize.sm"
                      (click)="downloadClickHandler(build, channel.type)">
                      {{ channelLabel(build, channel) }}
                    </mbs-button>

                    @if (isConnect()) {
                      <mbs-button
                        class="ml-1"
                        icon="fa fa-clone"
                        [disabled]="unsupportedByCompany"
                        [isCtrl]="true"
                        [ngbTooltip]="'shared:buttons.copyLink' | i18next"
                        [size]="mbsSize.sm"
                        (click)="copyLinkClickHandler(build, channel.type)"></mbs-button>
                    } @else if (isCommandSupported(build)) {
                      <mbs-button
                        class="ml-1"
                        icon="fa fa-clone"
                        [disabled]="unsupportedByCompany"
                        [isCtrl]="true"
                        [ngbTooltip]="'wizards:entityWizards.company.downloadStep.copyInstallationScript' | i18next"
                        [size]="mbsSize.sm"
                        (click)="copyCommandClickHandler(build, channel.type)"></mbs-button>
                    }
                  </span>

                  @if (!$last) {
                    <span class="text-gray-500 mx-1">|</span>
                  }
                }

                @if (canGenerate(build)) {
                  <mbs-button
                    type="secondary"
                    [class.ml-2]="channels.length"
                    [disabled]="isAnyBuildInProgress()"
                    [loading]="isBuildInProgress(build)"
                    [size]="mbsSize.xs"
                    (click)="generateClickHandler(build)">
                    {{ 'shared:buttons.generate' | i18next: { format: 'title' } }}
                  </mbs-button>
                }
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</section>
